import Molde from "./MoldeTourTradicionalAventura";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function CuatriMarasMoray() {
  return (
    <>
      <Molde
        image={"/images/cuatri-maras-moray-portada.png"}
        title={"CUATRIMOTOS"}
        subtitle={"(MARAS - MORAY)"}
        description={
          "Empezaremos el tour con el recojo desde su hotel en Cusco alrededor de las 7:00 a.m. y nos dirigiremos hacia el norte de la ciudad del Cusco en un viaje de 1 hora, llegando a nuestra base de operaciones ubicada en el sector llamado Cruzpata. Posteriormente, se nos asignarán cuatrimotos, donde nuestro instructor nos enseñará como utilizar nuestra cuatrimoto(ATV); después de una práctica y teniendo el OK del instructor, continuaremos nuestro recorrido en un viaje de 40 min. por senderos y paisajes, visitando las terrazas experimentales de Moray que son Andenes creados por los Incas en forma de un anfiteatro hundido, se dice que estos andenes tuvieron un propósito muy importante para la creación de microclimas y ayudar al crecimiento de las plantas, disfrutaremos de una vista increíble, aprenderemos sobre la ingeniosa agricultura Inca y estas terrazas. Finalizada la visita a Moray retornaremos a nuestra base en Cruzpata para dejar las ATV (cuatrimotos) y trasladarnos a las Salineras de Maras, donde el guía le proporcionará información detallada de la forma artesanal de la producción de sal. Finalmente, tomaremos nuestro transporte de vuelta a la ciudad del Cusco y su hotel, terminando el tour a las 14:00 p.m. aproximadamente."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 35.00"}
        moneda={"DOLARES"}*/
        picture={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri-maras-moray-1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri-maras-moray-2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri-maras-moray-3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri-maras-moray-4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri-maras-moray-5.png`} alt="" />
            </>
          }
        incluye={
          <>
            <li>Información previa al tour.</li>
            <li>Traslados desde Cusco a la base de las cuatrimotos, ida y retorno.</li>
            <li>Ruta, zona de trochas y miradores, aventura al 100%.</li>
            <li>Cuatrimotos.</li>
            <li>Equipo de seguridad (casco, guantes, lentes).</li>
            <li>Servicio de Guía profesional inglés - español.</li>
          </>
        }
        noIncluye={
          <>
            <li>Entradas a Moray (BTC), o Salineras.</li>
            <li>Almuerzo.</li>
            <li>Noche de hotel en Cusco.</li>
            <li>Otros servicios no mencionados.</li>
          </>
        }
        recomendaciones={
          <>
            <li>Mochila pequeña para llevar sus pertenencias personales.</li>
            <li>Lleve su pasaporte.</li>
            <li>Zapatos o zapatillas de deporte.</li>
            <li>Ropa cómoda.</li>
            <li>Gorro o Sombrero.</li>
            <li>Bloqueador solar.</li>
            <li>Lentes de Sol.</li>
            <li>Agua.</li>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Media"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"5 Horas"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Aventura"}
              />
            </>
          }

        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cuatri_maras_6.png`} alt="" />
            </>
          }
        TourRecomienda={
          <>
            <>
                        <CardRecomienda
                            img={"/images/montania_colores.png"}
                            title={"MONTAÑA 7 COLORES"}
                            puntuacion={"4.5"}
                            link={'/tour-tradicional/montania-colores'}
                        />
                        <CardRecomienda
                            img={"/images/valle-vip-5.png"}
                            title={"VALLE VIP"}
                            puntuacion={"5"}
                            link={'/tour-tradicional/valle-vip'}
                        />
                        <CardRecomienda
                            img={"/images/cris-1.png"}
                            title={"CITY TOUR"}
                            puntuacion={"5"}
                            link={'/tour-tradicional/citytour'}
                        />
                        <CardRecomienda
                            img={"/images/maras-moray-4.png"}
                            title={"MARAS-MORAY"}
                            puntuacion={"4.5"}
                            link={'/tour-tradicional/maras-moray'}
                        />
                    </>
          </>
        }
      />
    </>
  );
}
